import { render, staticRenderFns } from "./EmployeeGroupForm.vue?vue&type=template&id=5b31581e&scoped=true"
import script from "./EmployeeGroupForm.vue?vue&type=script&lang=js"
export * from "./EmployeeGroupForm.vue?vue&type=script&lang=js"
import style0 from "./EmployeeGroupForm.vue?vue&type=style&index=0&id=5b31581e&prod&lang=scss"
import style1 from "./EmployeeGroupForm.vue?vue&type=style&index=1&id=5b31581e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b31581e",
  null
  
)

export default component.exports